module.exports = __webpack_public_path__ + "img/anquan.782bf939.svg";